export const URLS = {
  REGISTER: 'user-management/identity/register',
  LOGIN: 'user-management/identity/login',
  CONTEXT_USER: 'user-management/users/me',
  FORBIDDEN: 'user-management/identity/login',
  FORGET_PASSWORD: 'user-management/identity/forget-password',
  CONFIRM_FORGET_PASSWORD: 'user-management/identity/confirm-forget-password',
  RESEND_OTP: 'user-management/identity/resend-otp',
  VERIFY_OTP: 'user-management/identity/verify-otp',
  CHANGE_PASSWORD: 'user-management/identity/change-password',
  CONFIRM_EMAIL: 'user-management/identity/confirmEmail',
  SEND_CONFIRM_EMAIL: 'user-management/identity/resendConfirmationEmail',
  RESET_PASSWORD: 'user-management/identity/resetPassword',
  BACKOFFICE_ROLES: 'user-management/backoffice-profiles',
  LOGOUT: 'logout',
  USERS: 'user-management/users',
  BACKOFFICE_PROFILES: 'user-management/backoffice-profiles',
  BACKOFFICE_PERMISSIONS: 'user-management/backoffice-profiles',
  BACKOFFICE_PERMISSIONS_GROUPS: 'user-management/backoffice-permission-groups',
  BACKOFFICE_USERS_ADMIN: 'user-management/backoffice-users/admin',
  BACKOFFICE_USERS: 'user-management/backoffice-users',
  PATIENTS: '/patients',
  PATIENTS_LIST: '/patients/list',
  PATIENTS_DETAILS: '/patients/details',
  PATIENT_PROFILES: 'patient-management/patient-profiles',
  DISEASE_CATEGORY_LIST: 'patient-management/disease-categories',
  SURGRYCATEGORY: 'patient-management/surgery-categories',
  SURGRIES: 'patient-management/surgeries',
  DISEASES: 'patient-management/diseases',
  Admission: 'patient-management/Admission',
  DISEASES_CATEGORIES: 'patient-management/disease-categories',
  PATIENT_CASES: 'patient-management/patient-profiles/cases',
  PATIENT_INVESTEGATIOIN: 'case-management/patient-profiles/',
  DOCTORS: 'supplier-management/doctors',
  HOSPITALS: 'supplier-management/hospitals',
  FAILURE: 'user-management/identity/login',
  ATTACHMENTS: 'utility-management/attachments',
  SERGRIES: 'patient-management/surgeries',
};
